"use client";
import {
  useTabStore
} from "../__chunks/7XCHEDST.js";
import {
  TabContextProvider
} from "../__chunks/QGC5LOGZ.js";
import "../__chunks/LM7KIZUU.js";
import "../__chunks/B7UTNDHN.js";
import "../__chunks/AMMIPFT4.js";
import "../__chunks/OLVWQA7U.js";
import "../__chunks/Y67KZUMI.js";
import "../__chunks/T2AZQXQU.js";
import "../__chunks/ABN76PSX.js";
import "../__chunks/APTFW6PT.js";
import "../__chunks/RTNCFSKZ.js";
import "../__chunks/5CPL3B7G.js";
import "../__chunks/VOQWLFSQ.js";
import "../__chunks/5GGHRIN3.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/tab/tab-provider.tsx
import { jsx } from "react/jsx-runtime";
function TabProvider(props = {}) {
  const store = useTabStore(props);
  return /* @__PURE__ */ jsx(TabContextProvider, { value: store, children: props.children });
}
export {
  TabProvider
};
